{
  "stay_in_touch": {
    "button": "Stay In Touch",
    "modal_title": "Stay in Touch",
    "set_frequency": "Set Frequency",
    "no_reminders_set": "You have not set any Stay in Touch Reminders",
    "due_date": "Due Date",
    "contact": "Contact",
    "firm": "Firm",
    "last_interaction": "Last Interaction",
    "select_frequency": "Select frequency",
    "reminder_active_message": "Stay in Touch reminder is active, and contacts have been added to My Contacts.",
    "stay_in_touch_aria_label": "Stay In Touch",
    "frequencies": {
      "every_three_months": "Every 3 Months",
      "every_six_months": "Every 6 Months",
      "every_year": "Every Year",
      "dont_stay_in_touch": "Don't Stay In Touch",
      "every_month": "Every Month",
      "every_week": "Every Week",
      "every_fortnight": "Every Fortnight"
    }
  },
  "contacts": {
    "actions": {
      "add_to_my_contact": "Add to My Contact",
      "add_contact": "Add Contact",
      "remove_confirmation": "Are you sure you want to remove this contact",
      "remove_title": "Please confirm to remove contact",
      "export_contacts": "Export Contacts"
    },
    "table": {
      "columns": {
        "contact": "Contact",
        "company": "Company",
        "location": "Location",
        "tags": "Tags",
        "last_interaction": "Last Interaction"
      },
      "selection": {
        "all_selected": "All {{count}} contacts selected",
        "add_to_list": "Add to List",
        "archive": "Archive",
        "log_new_activity": "Log New Activity",
        "add_to_list_success": "Request sent. It might take a few minutes to see all the contacts in the target list"
      }
    },
    "states": {
      "empty": {
        "title": "No Contacts to Review",
        "description": "New contacts will appear here for your review",
        "alt_text": "No contacts to review",
        "description_list": "There's no contact to show here"
      },
      "not_found": {
        "title": "No Contact Found",
        "description": "We couldn't find any contacts matching your search",
        "alt_text": "Success"
      }
    },
    "filters": {
      "company_type": "Company type",
      "consent_status": "Consent status",
      "company_hierarchy": "Company Hierarchy"
    },
    "forms": {
      "email_label": "Email",
      "email_required": "Email is required",
      "email_invalid": "This is not a email"
    },
    "export": {
      "title": "My Contacts",
      "description": "Add my contacts to list",
      "primary_view": "my contact view"
    },
    "tabs": {
      "my_contacts": "My Contacts"
    },

    "order_by": {
      "label": "Order by",
      "company_name_asc": "company name asc",
      "company_name_desc": "company name desc",
      "created_at_asc": "created at asc",
      "created_at_desc": "created at desc",
      "first_name_asc": "first name asc",
      "first_name_desc": "first name desc",
      "last_interaction_asc": "last interaction asc",
      "last_interaction_desc": "last interaction desc",
      "last_name_asc": "last name asc",
      "last_name_desc": "last name desc",
      "total_interaction_asc": "total interaction asc",
      "total_interaction_desc": "total interaction desc"
    },
    "aria_labels": {
      "is_private_contact": "Is private contact",
      "view_contact_hierarchy": "view contact hierarchy"
    }
  },
  "prospects": {
    "actions": {
      "search_prospects": "Search Prospects"
    },
    "tabs": {
      "my_prospects": "My Prospects"
    }
  },
  "opportunities": {
    "tabs": {
      "my_opportunities": "My Opportunities"
    },
    "filters": {
      "referral_source": "Referral Source",
      "date": "Date"
    }
  },
  "companies": {
    "actions": {
      "remove_confirmation": "Are you sure you want to remove this company",
      "remove_title": "Please confirm to remove this company",
      "remove_from_my_companies": "Remove from my companies"
    },
    "order_by": {
      "label": "Order by",
      "company_name_asc": "company name asc",
      "company_name_desc": "company name desc",
      "last_interaction_asc": "last interaction asc",
      "last_interaction_desc": "last interaction desc",
      "total_interaction_asc": "total interaction asc",
      "total_interaction_desc": "total interaction desc"
    },
    "filters": {
      "type": "Type"
    },
    "states": {
      "empty": {
        "description": "There's no company to show here"
      }
    },
    "tabs": {
      "my_companies": "My Companies"
    },
    "export": {
      "primary_view": "my company view"
    }
  },
  "journey": {
    "title": "My Journey",
    "errors": {
      "failed_to_set_embed_url": "Failed to set embed URL"
    }
  }
}
